import {
  Button,
  Layout,
  Menu,
  Image,
  Dropdown,
  MenuProps,
  Avatar,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import {
  ArrowLeft,
  ClientsIcon,
  CompaniesIcon,
  ContractsIcon,
  CrewsIcon,
  DashboardIcon,
  MaterialsIcon,
  MenuClosingIcon,
  MenuOpeningIcon,
  PropertiesIcon,
  ProposalsIcon,
  ReportsIcon,
  SbLogoutIcon,
  SbSettingsIcon,
  SbUserIcon,
  ScheduleIcon,
  TeamIcon,
  TicketsIcon,
  UsersIcon,
} from "../../../atoms/CustomIcons";
import { MoreOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogout } from "../../../organisms/Login/ducks/actions";
import { useAppSelector } from "../../../config/hooks";
import useWindowDimensions, {
  getInitials,
  POSITION_NAMES,
} from "../../../config/utils";

const { Header, Sider } = Layout;

interface SidebarProps {
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  collapsed: boolean;
}

const SidebarMenu = (props: SidebarProps) => {
  const { setCollapsed, collapsed } = props;
  const [collapsedMenu, setCollapsedMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  const logOut = useLogout();
  const { width } = useWindowDimensions();
  const myProfileData = useAppSelector(
    (state) => state?.myProfile?.userData?.data
  );

  const normalMenu = [
    {
      key: "1",
      label: (
        <Button
          onClick={() =>
            window.open(
              "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2972-165615&p=f&viewport=-741%2C42%2C0.07&t=TfgqbPXG9JHP8C74-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2972%3A165615",
              "_blank"
            )
          }
        >
          <DashboardIcon /> Dashboard
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          onClick={() =>
            window.open(
              "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2972-162981&p=f&viewport=-741%2C42%2C0.07&t=TfgqbPXG9JHP8C74-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2972%3A162981",
              "_blank"
            )
          }
        >
          <ReportsIcon /> Reports
        </Button>
      ),
    },
    {
      key: "clients",
      label: (
        <Button onClick={() => navigate(`/clients/${companyId}`)}>
          <ClientsIcon /> Clients
        </Button>
      ),
    },
    {
      key: "properties",
      label: (
        <Button onClick={() => navigate(`/properties/${companyId}`)}>
          <PropertiesIcon /> Properties
        </Button>
      ),
    },
    {
      key: "potential-deals",
      label: (
        <Button onClick={() => navigate(`/potential-deals/${companyId}`)}>
          <ProposalsIcon /> Potential deals
        </Button>
      ),
    },

    {
      key: "contracts",
      label: (
        <Button onClick={() => navigate(`/contracts/${companyId}`)}>
          <ContractsIcon /> Contracts
        </Button>
      ),
    },
    {
      key: "scheduling",
      label: (
        <Button onClick={() => navigate(`/scheduling/${companyId}`)}>
          <ScheduleIcon /> Schedule
        </Button>
      ),
    },
    {
      key: "work-orders",
      label: (
        <Button onClick={() => navigate(`/work-orders/${companyId}`)}>
          <TicketsIcon /> Work orders
        </Button>
      ),
    },
    {
      key: "crews",
      label: (
        <Button onClick={() => navigate(`/crews/${companyId}`)}>
          <CrewsIcon /> Crews & Subs
        </Button>
      ),
    },
    {
      key: "inventory",
      label: (
        <Button onClick={() => navigate(`/inventory/materials/${companyId}`)}>
          <MaterialsIcon /> Inventory
        </Button>
      ),
    },
    // {
    //   key: "12",
    //   label: (
    //     <Button onClick={() => navigate(`/company-settings/${companyId}`)}>
    //       <VendorsIcon /> Vendors
    //     </Button>
    //   ),
    // },
  ];

  const superAdminMenu = [
    {
      key: "companies",
      label: (
        <Button onClick={() => navigate("/companies")}>
          <CompaniesIcon /> Companies
        </Button>
      ),
    },
    {
      key: "customer-users",
      label: (
        <Button onClick={() => navigate("/customer-users")}>
          <UsersIcon /> Customer users
        </Button>
      ),
    },
    {
      key: "admin-team",
      label: (
        <Button onClick={() => navigate("/admin-team")}>
          <TeamIcon /> Admin team
        </Button>
      ),
    },
  ];

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={() => navigate(`/my-profile/${companyId}`)}
        >
          <SbUserIcon /> My profile
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={() => navigate(`/company-settings/${companyId}`)}
        >
          <SbSettingsIcon /> Company settings
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button type="text" className="no-hover" onClick={() => logOut()}>
          <SbLogoutIcon /> Log out
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (width < 767) {
      setCollapsed(true);
    }
  }, [width, setCollapsed]);

  const getSelectedMenuItemKey = () => {
    if (location.pathname.includes("my-profile")) {
      return "";
    }

    if (
      location.pathname.includes("companies") &&
      myProfileData?.type?.toLowerCase() === "super_admin"
    ) {
      return "companies";
    }

    if (
      location.pathname.includes("admin-team") &&
      myProfileData?.type?.toLowerCase() === "super_admin"
    ) {
      return "admin-team";
    }

    if (
      location.pathname.includes("customer-users") &&
      myProfileData?.type?.toLowerCase() === "super_admin"
    ) {
      return "customer-users";
    }

    if (location.pathname.includes("tasks")) {
      return "work-orders";
    }

    if (location.pathname.includes("subs")) {
      return "crews";
    }

    return location?.pathname?.split("/")[1];
  };
  const currentPath = getSelectedMenuItemKey();

  const insideCompany = () => {
    if (
      location.pathname.includes("companies") &&
      myProfileData?.type?.toLowerCase() === "super_admin"
    ) {
      return false;
    }

    if (
      location.pathname.includes("admin-team") &&
      myProfileData?.type?.toLowerCase() === "super_admin"
    ) {
      return false;
    }

    if (
      location.pathname.includes("customer-users") &&
      myProfileData?.type?.toLowerCase() === "super_admin"
    ) {
      return false;
    }

    return true;
  };

  return (
    <Sider trigger={null} collapsible collapsed={collapsed} collapsedWidth={68}>
      <Header>
        <Image
          src={
            collapsed
              ? "/images/login/logo-small.svg"
              : "/images/login/logo.svg"
          }
          alt="Logo"
          preview={false}
          width={collapsed ? 36 : 126}
        />
        {width > 767 && (
          <Tooltip
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            placement="right"
            getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
            open={collapsedMenu}
            onOpenChange={(visible) => setCollapsedMenu(visible)}
          >
            <Button
              type="link"
              className="only_icon"
              icon={collapsed ? <MenuOpeningIcon /> : <MenuClosingIcon />}
              onClick={() => {
                setCollapsed(!collapsed);
                setCollapsedMenu(false);
              }}
              style={{
                padding: "4px",
              }}
            />
          </Tooltip>
        )}
      </Header>
      <div className="sidebar_menu">
        {myProfileData?.type && (
          <>
            {myProfileData?.type?.toLowerCase() === "super_admin" &&
              insideCompany() && (
                <Button
                  onClick={() => navigate("/companies")}
                  type="text"
                  className="adminPanelMenu"
                >
                  <ArrowLeft /> Admin panel
                </Button>
              )}
            <Menu
              mode="inline"
              selectedKeys={currentPath ? [currentPath] : []}
              items={
                myProfileData?.type?.toLowerCase() === "super_admin" &&
                !insideCompany()
                  ? superAdminMenu
                  : normalMenu
              }
            />
          </>
        )}
      </div>

      <div className="user_details">
        <Dropdown
          menu={{
            items:
              myProfileData?.type?.toLowerCase() === "super_admin" &&
              !insideCompany()
                ? items.filter((item) => item?.key !== "2")
                : items,
          }}
          trigger={["click"]}
          placement="top"
          overlayClassName={
            collapsed ? "side_dropdown side_drop_collapsed" : "side_dropdown"
          }
        >
          <div className="sidebar_user_menu">
            {myProfileData?.image_url ? (
              <Avatar
                src={`${
                  myProfileData?.image_url ??
                  "/images/myProfile/upload-avatar.png"
                }`}
                className="avatar"
                size={36}
              />
            ) : myProfileData?.first_name && myProfileData?.last_name ? (
              <Avatar
                style={{ backgroundColor: "#6454F4", border: 0 }}
                size={36}
              >
                {getInitials(
                  myProfileData?.first_name,
                  myProfileData?.last_name
                )}
              </Avatar>
            ) : (
              <Avatar
                src="/images/myProfile/upload-avatar.png"
                className="avatar"
                size={36}
              />
            )}
            <div className="user_info">
              <h3>{`${myProfileData?.first_name ?? ""} ${
                myProfileData?.last_name ?? ""
              }`}</h3>
              <p>
                {myProfileData?.position_id
                  ? POSITION_NAMES[myProfileData?.position_id]
                  : myProfileData?.type?.replace(/_/g, " ")?.toLowerCase()}
              </p>
            </div>
            <div className="more_options">
              <MoreOutlined />
            </div>
          </div>
        </Dropdown>
      </div>
    </Sider>
  );
};

export default SidebarMenu;
